<script>
	import { onMount, onDestroy, getContext } from "svelte";
	import ADSBMarkerSet from "../components/adsbMarkerSet";
	import { globalOverlay } from '../map'

	export let filterRadioId = null

	const GLOBAL_CLEANUP_INTERVAL = 10 * 1000; // 10s
	const MAX_LAST_SEEN = 60 * 1000; // 1m

	let markerSet;

	let globalFeed = getContext("GlobalFeed");

	$: markerSet?.filter(filterRadioId)

	onMount(() => {
		markerSet = new ADSBMarkerSet(
			"ADSB",
			{ maxLastSeen: MAX_LAST_SEEN },
			globalOverlay
		);

		globalFeed.addEventListener("AIR_TRAFFIC", onAirTraffic);

		cleanup();
	});
	onDestroy(() => {
		if (markerSet) {
			markerSet.cleanup();
		}
		if (globalFeed) {
			globalFeed.removeEventListener("AIR_TRAFFIC", onAirTraffic);
		}
	});

	function onAirTraffic(ev) {
		markerSet.update(ev.detail);
	}

	function cleanup() {
		markerSet.clean(Date.now());
		setTimeout(cleanup, GLOBAL_CLEANUP_INTERVAL);
	}
</script>
